import { render } from "./TaskCategories.vue?vue&type=template&id=b2eec906"
import script from "./TaskCategories.vue?vue&type=script&lang=js"
export * from "./TaskCategories.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__